import clsx from 'clsx';

interface Props {
  containerRef: (node: HTMLDivElement | null) => void;
  visible: boolean;
  className?: string;
}

export function SmartCaptchaWidget({containerRef, visible, className}: Props) {
  if (!visible) {
    return null;
  }

  return (
    <div ref={containerRef} className={clsx('mb-20 min-h-100', className)} />
  );
}
